// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1510":"a5261cce","2338":"a5261cce","4092":"a5261cce","6709":"a5261cce"}[chunkId] + ".chunk.css";
};